import Fuse from 'fuse.js';

const options = {
	threshold: 0.0,
	ignoreLocation: true,
	keys: [
		{ name: 'name', getFn: (download) => download.name },
		{ name: 'filename', getFn: (download) => download.filename },
	],
};

export default (contents = []) => ({
	searchString: '',
	listContents: contents,
	isLoading: false,
	fuseInstances: contents.map((item) => new Fuse(item.downloads, options)),
	isSearching() {
		return !!this.searchString;
	},
	setSearchResultContents() {
		this.isLoading = true;
		if (this.isSearching()) {
			this.listContents = this.fuseInstances.map((instance, index) => {
				const searchExpression = {
					$and: this.searchString
						.split(/\s+/)
						.filter((s) => s)
						.map((s) => ({ name: s })),
				};
				console.log(searchExpression);
				return {
					...contents[index],
					downloads: instance
						.search(searchExpression)
						.map((e) => e.item),
				};
			});
			this.isLoading = false;
		} else {
			this.isLoading = false;
			this.listContents = contents;
		}
	},
	init() {
		console.log(contents);
	},
});
